import React, { useState } from "react";

import { Link } from "react-router-dom";

import Head from "../../components/Head/Head";
import NavBar from "../../components/NavBar/NavBar";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import Footer from "../../components/Footer/Footer";

import BlogContent from "../../data/blog";

import "./Blog.css";

const Blog = () => {
  const [limit, setLimit] = useState(10);
  const blogsNumber = BlogContent.length;
  const blogs = BlogContent.slice(0, limit);

  const handleLoadMore = () => {
    setLimit((limit) => limit + 10);
  };

  return (
    <>
      <Head
        title={"Oneconverse Translations | Blog"}
        description={
          "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
        }
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />
      <NavBar white />

      <div className="blog__hero position-relative d-flex flex-column align-center justify-center">
        <h2 className="position-relative z-2 font-large lh-lg">Blog</h2>
        <h3 className="position-relative z-2 font-subhead">Home - Blog</h3>
      </div>
      {blogsNumber === 0 && <h2 className="text-center">No Blog Found</h2>}
      <div className="blog__grid m-40 grid c-2 gap-40">
        {blogs.map((blog, i) => (
          <Link
            to={`/blog/${blog.topic.split(" ").join("-")}`}
            className="blog__card border-1 rounded px-20 py-40 pointer"
            key={blog.topic.concat(i)}
          >
            <div></div>
            <p className="font-bold font-subhead pt-20 pb-40">{blog.topic}</p>
            <p className="font-big mt-40">{blog.date}</p>
            <p className="font-big my-10">By {blog.author}</p>
          </Link>
        ))}
      </div>
      <div className="blog__btn d-flex justify-center">
        {blogsNumber > blogs.length && (
          <button
            className="border-0 outline-0 py-10 px-40 font-bold font-big rounded"
            onClick={handleLoadMore}
          >
            Load More
          </button>
        )}
      </div>

      <div className="blog__bottom container">
        <InstantQuote />
      </div>
      <Footer />
    </>
  );
};

export default Blog;
